<h2 class="mt-5 mb-5 text-center">
  <span class="active left-count">1</span>
  <!-- {{ 'Lost Pet Info' | translate }} -->
  {{ 'Information about missing animals' | translate}}
  <span class="right-count" (click)="onSubmit()">2</span>
</h2>
<div class="container">
  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
    <div class="row mt-5 pt-5 mb-5">
      <!-- <div class="col-sm-12">
        <div class="registerpet-pg">
          <h1>Registrering av funnet kjæledyr</h1>
          <p class="register-details">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ipsum, pellentesque
            cursus
            sed iaculis. Pretium, auctor metus adipiscing suscipit tincidunt auctor.</p>
        </div>
      </div> -->

      <div class="col-sm-12">
        <div class="registerforpet-form">
          <!-- <h1>Sted og dato funnet</h1> -->
          <div class="width-100 mb-5">
            <div class="form-feilds">
              <label class="required-star">{{'Pet Image' | translate }}</label>
              <div class="upload-petsphoto">
                <div class="muliple-photos">
                  <div [ngClass]="{'is-invalid':submitted && petf.Image.errors}">
                    <input type="file" #imgctrl (change)="fileProgress($event)" formControlName="Image">
                    <span><img [src]="previewUrl" alt="" title=""></span>
                  </div>
                </div>
              </div>
              <div style="font-size: 80%;color: #dc3545;" id="error-msg">{{ imageError | translate }}</div>
            </div>
          </div>

          <div class="width-100 mb-0">
            <div class="form-feilds mb-3">
              <div class="gender-dec yesno">
                <label class="doyounumber">{{ 'Do you have chipnumber' | translate }}</label>
                <div class="pets-gender" id="IsChipped" tabindex="1">
                  <div class="option-radio">
                    <label class="form-check-label" for="IsChippedYes">{{ 'Yes' | translate }}</label>
                    <input class="form-check-input" type="radio" name="IsChipped" formControlName="IsChipped"
                      (change)="onIsChippedChange()" id="IsChippedYes" value="1">
                  </div>
                  <div class="option-radio">
                    <label class="form-check-label" for="IsChippedNo">{{ 'No' | translate }}</label>
                    <input class="form-check-input" type="radio" formControlName="IsChipped" name="IsChipped"
                      (change)="onIsChippedChange()" id="IsChippedNo" value="0">
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-0" *ngIf="registerForm.controls.IsChipped.value == '1'">
            <div class="form-feilds mb-3">
              <label class="">{{'Chipnumber' | translate }} </label>
              <input type="text" class="form-control" #ChipID placeholder="{{ 'Enter chipnumber' | translate}}"
                formControlName="ChipID" minlength="4" maxlength="20"
                [ngClass]="{'is-invalid':submitted && petf.ChipID.errors}" (blur)="getChipInfo();">
              <div *ngIf="submitted && petf.ChipID.errors" class="invalid-feedback">
                <div *ngIf="petf.ChipID.errors.required">{{'Chip Number is required' | translate}}</div>
                <div *ngIf="petf.ChipID.errors.minlength">{{'Chip Number is of more then 4 char'| translate}}</div>
                <div *ngIf="petf.ChipID.errors.maxlength">{{'Chip Number is not more then 20 char' | translate}}</div>
                <div *ngIf="petf.ChipID.errors.whitespace && !petf.ChipID.errors.required">{{'Space is not
                  allowed'|
                  translate}}</div>
              </div>
              <span style="color: green;font-size: 13px;">{{ chipFound }}</span>
            </div>
          </div>

          <div class="width-100 mb-0" *ngIf="registerForm.controls.IsChipped.value == '1'">
            <div class="form-feilds mb-3">
              <div class="gender-dec">
                <label class="">{{'Show chipnumber to others' | translate }} </label>
                <div class="toggle-swicther">
                  <div [ngClass]="isChipIdToShowInDetail ? 'toggle-btn active' : 'toggle-btn'"
                    (click)="toggleShowChipNumber()">
                    <input type="checkbox" style="display: none;" value="1" class="form-check-input" id="exampleCheck1"
                      formControlName="IsChipIDinDetail">
                    <div class="inner-circle"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="required-star">{{ 'NickName' | translate }}</label>
              <input type="text" class="form-control" minlength="3" maxlength="60" formControlName="PetName"
                [ngClass]="{'is-invalid':submitted && petf.PetName.errors}">
              <div *ngIf="submitted && petf.PetName.errors" class="invalid-feedback">
                <div *ngIf="petf.PetName.errors.required">{{'Pet name is required'| translate}}</div>
                <div *ngIf="petf.PetName.errors.minlength">{{'Pet name is of more then 3 char'| translate}}</div>
                <div *ngIf="petf.PetName.errors.maxlength">{{'Pet name is not more then 60 char' | translate}}</div>
                <div *ngIf="petf.PetName.errors.whitespace && !petf.PetName.errors.required">{{'Space is not
                  allowed'|translate}}</div>
              </div>
            </div>
          </div>


          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="required-star">{{ 'Choose Species' | translate }}</label>
              <select class="form-control" [ngClass]="{'is-invalid':submitted && petf.MasterSpeciesID.errors}"
                formControlName="MasterSpeciesID" style="width: 100%;" (change)=getBreeds()>
                <option value="" selected disabled>{{'Select' |translate }}</option>
                <option *ngFor="let spc of MasterSpecies" [value]="spc.Value">{{spc.Text}}</option>
              </select>
              <div *ngIf="submitted && petf.MasterSpeciesID.errors" class="invalid-feedback">
                <div *ngIf="petf.MasterSpeciesID.errors.required">{{'Species is required' | translate}}</div>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="">{{ 'Breed' | translate }}</label>
              <select class="form-control" formControlName="MasterBreedID" style="width: 100%;"
                [ngClass]="{'is-invalid':submitted && petf.MasterBreedID.errors}" (change)=getSuggestion()>
                <option value="" selected>{{'Do not Know' |translate }}</option>
                <option *ngFor="let brd of MasterBreeds" [value]="brd.Value">{{brd.Text}}</option>
              </select>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label>{{ 'Gender' | translate }}</label>
              <div class="d-none d-sm-block" role="radiogroup" id="Gender">
                <div class="pets-gender mb-4">
                  <div class="custom-radio">
                    <label for="male" style="margin-left:40px;">{{'Male' | translate }}</label>
                    <input type="radio" id="male" [value]="1" name="Gender" formControlName="Gender"
                      class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="female" style="margin-left:40px;">{{'Female' | translate }}</label>
                    <input type="radio" id="female" [value]="2" name="Gender" formControlName="Gender"
                      class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="DoNotKnow" style="margin-left:40px;">{{ 'Do not Know' | translate }}</label>
                    <input type="radio" id="DoNotKnow" [value]="0" name="Gender" formControlName="Gender"
                      class="form-check-input">
                  </div>
                </div>
              </div>

              <div class="pets-gender d-block d-sm-none">
                <select class="form-control" formControlName="Gender" style="width: 100%;">
                  <option value="1">{{'Male' |translate }}</option>
                  <option value="2">{{'Female' |translate }}</option>
                  <option value="0" selected>{{'Do not Know' |translate }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-2">
              <label>{{ 'HairType' | translate }}</label>
              <div class="d-none d-sm-block">
                <div class="pets-gender mb-4" id="HairType">
                  <div class="custom-radio">
                    <label for="longhair" style="margin-left:40px;">{{ 'LongHair' | translate }}</label>
                    <input type="radio" id="longhair" [value]="1" formControlName="HairType" class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="sorthair" style="margin-left:40px;">{{ 'ShortHair' | translate }}</label>
                    <input type="radio" id="sorthair" [value]="2" formControlName="HairType" class="form-check-input">
                  </div>
                  <div class="custom-radio">
                    <label for="hairDoNotKnow" style="margin-left:40px;">{{ 'Do not Know' | translate }}</label>
                    <input type="radio" id="hairDoNotKnow" [value]="0" formControlName="HairType"
                      class="form-check-input">
                  </div>
                </div>
              </div>

              <div class="pets-gender d-block d-sm-none">
                <select class="form-control" formControlName="HairType" style="width: 100%;">
                  <option value="1">{{'LongHair' |translate }}</option>
                  <option value="2">{{'ShortHair' |translate }}</option>
                  <option value="0" selected>{{'Do not Know' |translate }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="">{{ 'Color' | translate }}</label>
              <input type="text" class="form-control" formControlName="Color" />
            </div>
          </div>


          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="">{{ 'Identification' | translate }}</label>
              <input type="text" class="form-control" formControlName="IdentificationMark" />
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="">{{ 'Age' | translate }} <span>({{ 'Year' | translate}})</span></label>
              <input type="number" name="petage" min="1" value="0" class="form-control" formControlName="Age" />
            </div>
            <div style="font-size: 80%;color: #dc3545;" id="Ageerror-msg">{{ ageError | translate }}</div>
          </div>

          <div class="width-100 mb-4">
            <div class="form-feilds required-star">
              <label>{{ 'Date when Lost' | translate }}</label>
            </div>
            <div class="date-details form-feilds d-sm-flex">
              <div class="custom-city mr-2">
                <input class="form-control" formControlName="LostFoundDate" type="datetime-local"
                  [min]="this.formattedminDate" [max]="this.formattedmaxDate">
              </div>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="required-star">{{'Area where lost' | translate }}</label>
              <div>
                <span class="map-info" style="font-size:13px !important">{{ 'Skriv inn og velg adressen eller bruk
                  markøren for å angi hvor kjæledyret ble
                  mistet/funnet' }}</span>
              </div>
              <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()" formControlName="Area"
                autocorrect="off" autocapitalize="off" placeholder="" spellcheck="off" type="text" #search
                [ngClass]="{'is-invalid':submitted && petf.Area.errors}">
              <div *ngIf="submitted && petf.Area.errors" class="invalid-feedback">
                <div *ngIf="petf.Area.errors.required">{{'Area is required'| translate}}</div>
              </div>

            </div>
            <!--<div *ngIf="isMinsideUser" class="col-sm-3 form-input-side">
              <button type="button" (click)="onClickFillAddress()" class="btn btn-secondary">{{ 'Fill Address' |
                translate
                }}</button>
            </div>-->
          </div>

          <div class="width-100 mb-2">
            <div class="d-flex width-100 form-feilds">
              <div class="custom-city mr-2">
                <input type="text" class="form-control" value="" style="background-color: white !important"
                  [readonly]="true" formControlName="ZipCode" placeholder="{{'Zipcode' | translate}}"
                  [ngClass]="{'is-invalid':submitted && petf.ZipCode.errors}">
                <!-- <div *ngIf="submitted && petf.ZipCode.errors" class="invalid-feedback">
                  <div *ngIf="petf.ZipCode.errors.required">{{'Zipcode is required'| translate}}</div>
                  <div *ngIf="petf.ZipCode.errors.whitespace">{{'Space is not allowed'| translate}}</div>
                </div> -->
              </div>

              <div class="custom-zipcode ml-2">
                <input type="text" class="form-control" value="" formControlName="City"
                  style="background-color: white !important" placeholder="{{ 'City' | translate }}"
                  [ngClass]="{'is-invalid':submitted && petf.City.errors}">
                <div *ngIf="submitted && petf.City.errors" class="invalid-feedback">
                  <div *ngIf="petf.City.errors.required">{{'City is required'| translate}}</div>
                  <div *ngIf="petf.City.errors.whitespace && !petf.City.errors.required">{{'Space is not allowed'|
                    translate}}</div>
                </div>
              </div>
            </div>

            <div style="margin-top:10px;display: none;">
              <div class="custom-city mr-2">
                <input type="text" class="form-control" tabindex="-1" value="" formControlName="District"
                  placeholder="District" [ngClass]="{'is-invalid':submitted && petf.District.errors}">
                <!-- <div *ngIf="submitted && petf.District.errors" class="invalid-feedback">
                  <div *ngIf="petf.District.errors.whitespace">{{'Space is not allowed'| translate}}</div>
                </div> -->
              </div>
              <div class="custom-zipcode ml-2">
                <input type="text" class="form-control" value="" tabindex="-1" formControlName="State"
                  placeholder="State" [ngClass]="{'is-invalid':submitted && petf.State.errors}">
                <!-- <div *ngIf="submitted && petf.State.errors" class="invalid-feedback">
                  <div *ngIf="petf.State.errors.required">{{'State is required'| translate}}</div>
                  <div *ngIf="petf.State.errors.whitespace && !petf.State.errors.required">{{'Space is not allowed'|
                    translate}}</div>
                </div> -->
              </div>
            </div>
          </div>

          <div class="width-100 mb-2" tabindex="-1">
            <div class="form-feilds mb-3" tabindex="-1">
              <label class="col-sm-3 col-form-label">{{ 'Map' | translate }}</label>
              <div class="col-sm-8 form-input-side map-mob" tabindex="-1">
                <agm-map [latitude]="lat" tabindex="-1" [longitude]="lng" [zoom]="zoom" [styles]="googleMapstyles"
                  [streetViewControl]="false">
                  <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true"
                    (dragEnd)="markerDragEnd($event)">
                  </agm-marker>
                </agm-map>
              </div>
            </div>
          </div>

          <!-- <div class="form-group">
            <label class="col-sm-3 col-form-label map-lbl2">{{ 'Map' | translate }}</label>
            <div class="col-sm-8 form-input-side map-mob" style="width: 600px;height: 300px;">
              <agm-map [latitude]="lat" [longitude]="lng" [zoom]="zoom">
                <agm-marker [latitude]="lat" [longitude]="lng" [markerDraggable]="true"
                  (dragEnd)="markerDragEnd($event)">
                </agm-marker>
              </agm-map>
            </div>
          </div> -->

          <div class="width-100 mb-2" style="display: none;">
            <div class="form-feilds mb-3">
              <select class="form-control" tabindex="-1" formControlName="Country" style="width: 100%;">
                <option value="" selected disabled>{{'Select' |translate }}</option>
                <option *ngFor="let cntry of country" [value]="cntry.Text">{{cntry.Text}}</option>
              </select>
            </div>
          </div>

          <div class="width-100 mb-2">
            <div class="form-feilds mb-3">
              <label class="d-none d-sm-block">{{ 'Additional Info' | translate }}</label>
              <label class="d-block d-sm-none">{{ 'Additional Info' | translate }}</label>
              <textarea class="form-control cus-texthgi" formControlName="AdditionalInfo"
                id="exampleFormControlTextarea1" rows="140" cols="50" placeholder=""></textarea>
            </div>
          </div>

        </div>
      </div>
    </div>

    <div class="form-check align-items-center col-12 mb-4" *ngIf="currentUser.Company" [hidden]="!ShowFacebookShare">
      <input (click)="ShareONFacebookClick()" type="checkbox" value="1" class="form-check-input" id="exampleCheck1" formControlName="ShareONFacebook">
      <a class="chkbx-terms" for="exampleCheck1">{{ 'Post on my Facebook Page' | translate }}</a>
    </div>
    <div class="btns-box regist-btm row">
      <div class="mt-2 mb-4 col-md-12">
        <button type="submit" class="btn btn-primary mr-3">{{ 'Next' | translate }}</button>
        <button type="button" class="btn btn-secondary" (click)=this.app.Cancel()>{{ 'Cancel' |
          translate
          }}</button>
        <button class="btn btn-lg btn-outline-primary" id="contentNew" (click)="open(content)"
          style="display: none;">Modal</button>
      </div>
    </div>
    <input type="text" class="form-control"  value="" formControlName="FacebookUserId"
                  placeholder="District" style="display: none;">
    <input type="text" class="form-control"  value="" formControlName="ShortLivedToken"
                  placeholder="District" style="display: none;">    
  </form>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{'Crop Image'| translate}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close('Save click')">{{'Save'|
      translate}}</button>
  </div>
  <div class="modal-body">
    <div class="text-center col-md-12">
      <image-cropper [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true" [aspectRatio]="4 / 4"
        [resizeToWidth]="256" format="png" (imageCropped)="imageCropped($event)" (imageLoaded)="imageLoaded()"
        (cropperReady)="cropperReady()" (loadImageFailed)="loadImageFailed()"></image-cropper>
    </div>
    <div class="text-center col-md-4">
      <h5>{{'Preview'|translate}}</h5>
      <img [src]="croppedImage" />
    </div>
  </div>
</ng-template>